module.exports = __webpack_public_path__ + "static/media/lisa_mobile.7ad8a729.webp";